import cn from 'classnames';
import { Highlight, Prism, themes } from 'prism-react-renderer';
import { memo } from 'react';

import { Condition } from '@/components/static';
import { isOneOf } from '@/utils/common';

import s from './styles.module.scss';
import { CodeBlockProps, PYGMENTS_TO_PRISM, PygmentsLang } from './utils';

const isValidLang = isOneOf(Object.keys(PYGMENTS_TO_PRISM) as PygmentsLang[]);

function Code({ lang, code, withLineNumbers }: CodeBlockProps) {
  return (
    <Highlight
      prism={Prism}
      theme={themes.github}
      code={code}
      language={isValidLang(lang) ? PYGMENTS_TO_PRISM[lang] : 'bash'}
    >
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <pre className={cn(className, s.high_light_content_wrapper)} style={{ ...style }}>
          {tokens.map((line, i) => (
            <div key={i} {...getLineProps({ line })}>
              <Condition when={Boolean(withLineNumbers)}>
                <span className={s.line_number}>{i + 1}</span>
              </Condition>
              {line.map((token, key) => (
                <span key={key} {...getTokenProps({ token })} />
              ))}
            </div>
          ))}
        </pre>
      )}
    </Highlight>
  );
}

export const CodeBlock = memo(Code);
